import { css } from '@emotion/react';
import { p2r, PrimaryProps } from '../../styles/fonts';
import { colors } from '../../styles/index';

const styles = css`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: ${p2r(64)};
  background-color: ${colors.gray};

  .sponsor-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;

    &__text {
      padding-left: 20px;
      margin: 0;
      font-size: ${p2r(14)};
      font-weight: 500;
      line-height: ${p2r(17)};
      color: ${colors.black};
      text-transform: initial;
      ${PrimaryProps}
    }
  }

  .sponsor-bar__container {
    display: flex;
  }

  .logo-header {
    width: 100%;
    max-width: 96px;
    max-height: 48px;
    margin: 0 20px ${p2r(5)} 0;
  }

  .icon-header {
    padding: 0 0 ${p2r(5)} 5px;
  }
`;

export default styles;
